import React, { useEffect, useState } from "react";
import {
  DeleteBestKeywords,
  GetBestKeywordsAll,
  UpdateBestKeywords,
} from "../../../../../../../../core/Services";
import { BsFillTrashFill } from "react-icons/bs";
import { BsFillPencilFill } from "react-icons/bs";
import { Dialog } from "primereact/dialog";
import { Button } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import { Paginator } from "primereact/paginator";

export default function BestKeywordsTable({
  uniqueCustomerId,
  tableKey,
  browser,
  months,
}) {
  const [keywords, setKeywords] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState(null);
  const [displayConfirmation, setDisplayConfirmation] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [editMode, setEditMode] = useState(null);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const toast = useToast();

  useEffect(() => {
    GetBestKeywordsAll(uniqueCustomerId)
      .then((data) => {
        setKeywords(data.data);
      })
      .catch((error) => {
        console.log("Ülke Veri Çekme Hatası", error);
      });
  }, [uniqueCustomerId, tableKey , deleteSuccess]);

  useEffect(() => {
    if (deleteSuccess) {
      toast({
        title: "Başarılı",
        description: "Veri başarıyla silindi.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
      setDeleteSuccess(false);
    }
  }, [deleteSuccess, toast]);

  const handleDelete = (keywordId) => {
    setSelectedKeywords(keywordId);
    setDisplayConfirmation(true);
  };

  const onDeleteConfirmation = () => {
    DeleteBestKeywords(selectedKeywords);
    setDeleteSuccess(true);
    setSelectedKeywords("");
    setDisplayConfirmation(false);
  };

  const onHide = () => {
    setDisplayConfirmation(false);
  };

  const handleEdit = (keywordId) => {
    setEditMode(keywordId);
  };

  const handleSave = (editedKeywords) => {
    UpdateBestKeywords(editedKeywords);
    setEditMode(null);
  };
  const handleInputChange = (event, keywordId) => {
    const { name, value } = event.target;
    const updatedKeywords = keywords?.map((keyword) =>
      keyword.id === keywordId ? { ...keyword, [name]: value } : keyword
    );
    setKeywords(updatedKeywords);
  };

    const onPageChange = (event) => {
      setFirst(event.first);
      setRows(event.rows);
    };

  return (
    <div>
      <div className="mb-3 font-bold text-xl">Tablo Görünümü :</div>
      <table
        style={{
          fontFamily: "arial, sans-serif",
          borderCollapse: "collapse",
          width: "80%",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            ></th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Dönem
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Platform
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Anahtar Kelime
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Kullanıcılar
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Görüntüleme Sayısı
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              İşlemler
            </th>
          </tr>
        </thead>
        <tbody>
          {keywords &&
            keywords?.slice(first, first + rows)?.map((keyword, index) => (
              <tr
                key={keyword.id}
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "left",
                  padding: "8px",
                }}
              >
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {editMode === keyword.id ? (
                    <input
                      type="text"
                      name="keywords"
                      value={keyword.keywords}
                      onChange={(e) => handleInputChange(e, keyword.id)}
                    />
                  ) : (
                    index + 1
                  )}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {months?.find((months) => months.value === keyword.month)
                    ?.name || ""}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {browser.find(
                    (browser) =>
                      Number(browser.value) === Number(keyword.platform)
                  )?.label || ""}
                </td>

                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {editMode === keyword.id ? (
                    <input
                      type="text"
                      name="keywords"
                      value={keyword.keywords}
                      onChange={(e) => handleInputChange(e, keyword.id)}
                    />
                  ) : (
                    keyword.keywords
                  )}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {editMode === keyword.id ? (
                    <input
                      type="text"
                      name="total"
                      value={keyword.total}
                      onChange={(e) => handleInputChange(e, keyword.id)}
                    />
                  ) : (
                    keyword.total
                  )}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {editMode === keyword.id ? (
                    <input
                      type="text"
                      name="screening"
                      value={keyword.screening}
                      onChange={(e) => handleInputChange(e, keyword.id)}
                    />
                  ) : (
                    keyword.screening
                  )}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {editMode === keyword.id ? (
                    <button onClick={() => handleSave(keyword)}>Kaydet</button>
                  ) : (
                    <button onClick={() => handleEdit(keyword.id)}>
                      <BsFillPencilFill />
                    </button>
                  )}
                  <button
                    className="ml-2"
                    onClick={() => handleDelete(keyword.id)}
                  >
                    <BsFillTrashFill />
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <Paginator
        first={first}
        rows={rows}
        totalRecords={keywords?.length}
        onPageChange={onPageChange}
      />
      <Dialog
        visible={displayConfirmation}
        style={{ width: "450px" }}
        onHide={onHide}
        position="center"
        header="İçerik Düzenleme"
      >
        <p>Veriyi silmek istediğinize emin misiniz?</p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <Button colorScheme="red" onClick={onHide}>
            Hayır
          </Button>
          <Button colorScheme="green" onClick={onDeleteConfirmation}>
            Evet
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
